import React from "react";
import RightMessage from "./RightMessage";
import RightAttachment from "./RightAttachment";
import RightImages from "./RightImages";
import RightTime from "./RightTime";
import RightAvatar from "./RightAvatar";
import { formatTime, initialsValue } from "../../../../../helpers";
import { useSelector } from "react-redux";
import Indentification from "../../../../elements/Indentification";
import Tooltip from "../../../../elements/Tooltip";

const RightSec = ({ group }) => {
  const { session } = useSelector((state) => state?.authProvider);

  return (
    <div className="flex items-end float-right mb-4 intro-x chat-text-box">
      <div className="w-full space-y-2">
        {group?.message?.map((msg, i) => {
          return (
            <div key={i?.toString()}>
              {!msg?.content && msg?.attachmentInfo?.length > 0 && (
                <div 
                // className="bg-primary h-10 rounded-md shadow"
                >
                  <RightImages
                    images={msg?.attachmentInfo
                      ?.filter((attach) => attach?.mediaType === "image")
                      ?.map((attach) => ({
                        src: attach?.url,
                        alt: attach?.name,
                      }))}
                    content={msg?.content || " "}
                  />
                  <div className="clear-both" />
                </div>
              )}
              {msg?.content && msg?.attachmentInfo?.length === 0 && (
                <RightMessage text={<div>{msg?.content}</div>} />
              )}
              <div className="clear-both" />
              {msg?.attachmentInfo?.length > 0 && (
                <>
                  <RightImages
                    images={msg?.attachmentInfo
                      ?.filter((attach) => attach?.mediaType === "image")
                      ?.map((attach) => ({
                        src: attach?.url,
                        alt: attach?.name,
                      }))}
                    content={msg?.content}
                  />
                  <div className="clear-both" />
                </>
              )}
              {msg?.seen_by_user?.length > 0 && (
                <>
                  <div className="flex items-center gap-1 justify-end my-1">
                    {msg?.seen_by_user?.map((user, j) => (
                      <React.Fragment key={j}>
                        <div className="relative flex-none overflow-hidden rounded-full w-5 h-5">
                          <Tooltip
                            message={`${user?.firstName || ""} ${
                              user?.lastName || ""
                            }`}
                            className={"w-5 h-5"}
                          >
                            <Indentification
                              image={user?.image?.url?.url}
                              alt={`${user?.firstName || ""} ${
                                user?.lastName || ""
                              }`}
                              initial={initialsValue(
                                `${user?.firstName || ""} ${
                                  user?.lastName || ""
                                }`
                              )}
                              className="w-full h-full"
                              initialStyle={{ fontSize: 8 }}
                            />
                          </Tooltip>
                        </div>
                      </React.Fragment>
                    ))}
                  </div>
                  <div className="clear-both" />
                </>
              )}
              {/* <RightAttachment
              fileName={"preview-10.jpg"}
              fileSize={"1.4 MB"}
              fileType={"Image"}
              ext={"PNG"}
            />
            <div className="clear-both" /> */}
              {group?.message?.length === i + 1 && (
                <>
                  <div className="clear-both mb-2" />
                  <RightTime
                    time={formatTime(group?.message?.at(-1)?.createdAt)}
                  />
                </>
              )}
            </div>
          );
        })}
      </div>
      <RightAvatar
        src={group?.user?.image?.url}
        alt={`${group?.user?.firstName || ""} ${group?.user?.lastName || ""}`}
      />
    </div>
  );
};

export default RightSec;
